// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const ChatConfig = () => (function(config: any) {
   const {
      widgets
   } = config

   return {
      email: widgets.chat_widget_email,
      location: widgets.chat_widget_location,
      offlineImage: widgets.chat_widget_offline_image,
      onlineImage: widgets.chat_widget_online_image,
      widget: (() => { switch (false) {
         case widgets.enable_whatsapp_chat !== true:
            return {
               type: 'whatsapp',
               number: widgets.whatsapp_number
            }
         case widgets.enable_libraryh3lp_chat !== true:
            return {
               type: 'libraryh3lp',
               queue: widgets.libraryh3lp_queue,
               skin: widgets.libraryh3lp_skin
            }
         case widgets.enable_springshare_chat !== true:
            return {
               type: 'springshare',
               iid: widgets.springshare_iid,
               // TODO: domain & key fields are now being pulled from a springshare
               //       API. Remove these fields once(if) we remove them from the Customizer.
               domain: widgets.springshare_domain,
               key: widgets.springshare_key
            }
         case widgets.enable_springshare_v2_chat !== true:
            return {
               type: 'springshare_v2',
               elementId: widgets.springshare_v2_element_id,
               scriptSrc: widgets.springshare_v2_script_src
            }
         case widgets.enable_qwidget_chat !== true:
            return {type: 'questionpoint'}
         default:
            return {}
      } })()
   }
})

angular.module('summonApp.factories.configs')
   .factory('chatConfig', ChatConfig)
